import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TabSessionService {
  private readonly TAB_KEY = 'active_app_tab4';
  constructor(private router: Router) {
    localStorage.removeItem('active_app_tab');
    localStorage.removeItem('active_app_tab2');
    localStorage.removeItem('active_app_tab3');
    this.initializeTabCheck();
  }
  private initializeTabCheck(): void {
    const allowedRoutes = [
      'Saving-Account',
      'privacy-policy',
      'terms-conditions',
      'security-tips',
      'help-support',
      'digilocker-callback',
      'open-page',
      'customer-kyc',
      'vpartner-maintenance',
      'no-internet'
    ];
    const firstSegment = window.location.pathname
      .split('/')
      .filter(Boolean)[0];
    const isMatched = allowedRoutes.includes(firstSegment);
    if (isMatched) {
      return;
    }
    const currentTabId = crypto.randomUUID();
    const existingTab = localStorage.getItem(this.TAB_KEY);
    if (existingTab) {

      this.router.navigate(['/login']);
      return;
    }
    localStorage.setItem(this.TAB_KEY, currentTabId);
    window.onbeforeunload = () => {
      const activeTab = localStorage.getItem(this.TAB_KEY);
      if (activeTab === currentTabId) {
        localStorage.removeItem(this.TAB_KEY);
      }
    };
  }
}